exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3qYwCG0Ofhke0dgw8chvMg{height:100%}.j4N_Q1tZM5wuGClyJuqSY{position:absolute;bottom:0;width:100%}", ""]);
// Exports
exports.locals = {
	"boardContainer": "_3qYwCG0Ofhke0dgw8chvMg",
	"devDeleteButton": "j4N_Q1tZM5wuGClyJuqSY"
};